import { render } from "./StartBillingBatchComponent.vue?vue&type=template&id=56dbe633&scoped=true"
import script from "./StartBillingBatchComponent.vue?vue&type=script&lang=js"
export * from "./StartBillingBatchComponent.vue?vue&type=script&lang=js"

import "./StartBillingBatchComponent.vue?vue&type=style&index=0&id=56dbe633&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56dbe633"]])

export default __exports__